export { OrganisationInfoModule } from './organisation-info';
export { PermissionService, OrganisationInfoStoreService } from './services';
